import { TireBasketPriceInfo } from './TireBasketPriceInfo';

export default TireBasketPriceInfo;
